import type { Dictionary } from "./types";

export const it: Dictionary = {
  nav: {
    navigation: "Navigazione",
    dashboard: "Dashboard",
    devices: "Dispositivi",
    map: "Mappa",
    settings: "Impostazioni",
    openMenu: "Apri menu",
    closeMenu: "Chiudi menu",
    admin: "Amministrazione",
    sites: "Siti",
    users: "Utenti",
  },
  dashboard: {
    title: "Dashboard",
    updatedAt: "Aggiornato alle",
    online: "Online",
    offline: "Offline",
    warning: "Attenzione",
    total: "Totale",
    batteryStatus: "Stato Batteria",
    batteryDistribution: "Distribuzione livelli batteria",
    batteryHigh: "Alta (>=60%)",
    batteryMedium: "Media (20-59%)",
    batteryLow: "Bassa (<20%)",
    inactivity: "Inattivita Dispositivi",
    inactivitySubtitle: "Animali senza movimenti rilevati",
    criticalCases: "Casi critici",
    allDevicesActive: "Tutti i dispositivi sono attivi",
    gatewayTitle: "Gateway LoRaWAN",
    gatewayOfOnline: "di",
    pktToday: "pkt oggi",
    devicesConnected: "dispositivi",
  },
  devicesPage: {
    title: "Dispositivi",
    trackersConfigured: "tracker GPS configurati",
    searchPlaceholder: "Cerca per nome o seriale...",
    allStatuses: "Tutti gli stati",
    tags: "Tag",
    removeAll: "Rimuovi tutti",
    devicesFound: "dispositivi trovati",
    deviceFound: "dispositivo trovato",
    name: "Nome",
    serial: "Seriale",
    status: "Stato",
    battery: "Batteria",
    lastSignal: "Ultimo segnale",
    tagsColumn: "Tag",
    config: "Config",
    site: "Sito",
    noSiteAssigned: "Nessun sito assegnato",
    selectSite: "Seleziona sito...",
    noSitesAvailable: "Nessun sito disponibile",
    assignSite: "Assegna a sito",
    noDevicesFound: "Nessun dispositivo trovato con i filtri applicati.",
    deviceInfo: "Info dispositivo",
    firmware: "Firmware",
    dataFrequency: "Frequenza dati",
    species: "Specie",
    gateway: "Gateway",
    actions: "Azioni",
    firmwareUpdate: "Aggiornamento firmware",
    changeDataFrequency: "Modifica frequenza dati",
    sendConfiguration: "Invia configurazione",
    deviceConfiguration: "Configurazione dispositivo",
    removeTag: "Rimuovi tag",
    loading: "Caricamento dispositivi...",
    errorLoading: "Errore nel caricamento",
    batteryHistory: "Cronologia batteria",
    noBatteryData: "Nessun dato batteria disponibile",
  },
  mapPage: {
    mapFilters: "Filtri Mappa",
    closePanel: "Chiudi pannello",
    device: "Dispositivo",
    searchDevice: "Cerca dispositivo...",
    allDevices: "Tutti i dispositivi",
    positionHistory: "Storico Posizioni",
    showHistoricTrack: "Mostra il percorso storico del dispositivo selezionato",
    dateRange: "Intervallo Date",
    from: "Da",
    to: "A",
    clearDateFilter: "Cancella filtro date",
    selectedDevice: "Dispositivo selezionato",
    lat: "Lat",
    lng: "Lng",
    battery: "Batteria",
    showAll: "Mostra tutti",
    filters: "Filtri",
    loadingMap: "Caricamento mappa...",
    speed: "Velocita",
    time: "Ora",
    pointOf: "Punto",
    downloadCsv: "Scarica CSV",
    showPolygonOverlay: "Area Sito",
    showPolygonOverlayHint: "Mostra/nascondi il poligono del sito sulla mappa",
    showGateways: "Gateway",
    showGatewaysHint: "Mostra/nascondi le antenne gateway sulla mappa",
    baseMapType: "Tipo mappa",
    baseMapStandard: "Standard",
    baseMapSatellite: "Satellitare",
    baseMapTerrain: "Elevazione",
  },
  settingsPage: {
    title: "Impostazioni",
    subtitle: "Preferenze applicazione",
    language: "Lingua",
    languageDescription: "Scegli la lingua dell'interfaccia",
    english: "English",
    italian: "Italiano",
  },
  time: {
    now: "Adesso",
    minAgo: "min fa",
    hoursAgo: "h fa",
    daysAgo: "g fa",
  },
  auth: {
    title: "Accesso al Portale",
    subtitle: "Effettua il login per visualizzare i tracker GPS",
    username: "Username",
    password: "Password",
    login: "Accedi",
    error: "Errore di autenticazione",
    invalidCredentials: "Credenziali non valide",
  },
  sitesPage: {
    title: "Siti",
    subtitle: "Gestisci i luoghi e le aree dei tuoi tracker",
    addSite: "Aggiungi Sito",
    editSite: "Modifica Sito",
    newSite: "Nuovo Sito",
    name: "Nome",
    description: "Descrizione",
    gpsLocation: "Posizione GPS",
    referenceGateway: "Gateway di Riferimento",
    selectGateway: "Seleziona un gateway...",
    latitude: "Latitudine",
    longitude: "Longitudine",
    sampleLat: "es: 45.4642",
    sampleLng: "es: 9.1900",
    areaPolygon: "Area (Poligono GPS) - Opzionale",
    polygonHint: "Seleziona i punti sulla mappa o usa i valori testuali. Minimo 3 punti per definire un'area.",
    save: "Salva",
    cancel: "Annulla",
    sitesList: "Elenco Siti",
    loading: "Caricamento...",
    noSitesFound: "Nessun sito trovato.",
    headers: {
      name: "Nome",
      description: "Descrizione",
      coordinates: "Coordinate",
      polygonArea: "Area Poligono",
      actions: "Azioni",
    },
    noData: {
      lat: "-",
      lng: "-",
    },
    alerts: {
      deleteConfirm: "Sei sicuro di voler eliminare questo sito?",
      siteCreatedError: "Errore durante la creazione del sito",
      siteUpdatedError: "Errore durante la modifica del sito",
      siteDeletedError: "Errore durante l'eliminazione del sito",
    },
    // Polygon editor
    polygonPointsTitle: "Punti del poligono",
    polygonPoint: "Punto",
    removePoint: "Rimuovi punto",
    polygonValid: "Poligono valido (minimo 3 punti)",
    pointsNeeded: "Occorrono ancora",
    pointsForPolygon: "punti per formare un poligono",
  },
  common: {
    createSecurePassword: "Crea una password sicura...",
    repeatPassword: "Ripeti la password...",
    centeredOnLocation: "Centrato sulla posizione GPS. Clicca per aggiungere punti al poligono.",
  },
  usersPage: {
    title: "Utenti",
    subtitle: "Gestisci gli utenti del portale",
    addUser: "Aggiungi Utente",
    editUser: "Modifica Utente",
    newUser: "Nuovo Utente",
    username: "Username",
    fullName: "Nome completo",
    password: "Password",
    confirmPassword: "Conferma Password",
    description: "Descrizione",
    siteAccess: "Accesso ai Sitì",
    selectSites: "Seleziona i siti a cui l'utente può accedere",
    save: "Salva",
    cancel: "Annulla",
    usersList: "Elenco Utenti",
    loading: "Caricamento...",
    noUsersFound: "Nessun utente trovato.",
    headers: {
      username: "Username",
      name: "Nome",
      description: "Descrizione",
      authorizedSites: "Siti Autorizzati",
      actions: "Azioni",
    },
    alerts: {
      passwordRequired: "La password è obbligatoria per un nuovo utente",
      passwordsMismatch: "Le password non corrispondono",
      usernameRequired: "L'username è obbligatorio",
      userCreatedError: "Errore durante la creazione dell'utente",
      userUpdatedError: "Errore durante la modifica dell'utente",
      userDeletedError: "Errore durante l'eliminazione dell'utente",
      deleteConfirm: "Sei sicuro di voler eliminare questo utente?",
      siteAccessTitle: "Accesso ai Sitì",
    },
  },
};
